import { AxiosResponse } from 'axios';
import HttpClient from '../utils/HttpClientHandler';
import { User } from '../types/User';

const UserService = class UserService {
    #baseURL: string;

    constructor() {
        this.#baseURL = '/users';
    }

    public async getAllUsers(): Promise<User[]> {
        const response: AxiosResponse = await HttpClient.get(`${this.#baseURL}/`);
        const {
            data: { message },
        }: { data: { message: User[] } } = response;
        return message;
    }
};

export default new UserService();
